import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Cliente } from 'src/app/admihair/api/dto/cliente';
import { ContatoCliente } from 'src/app/admihair/api/dto/contato-cliente';
import { ClienteService } from 'src/app/admihair/service/cliente.service';
import { ContatoClienteService } from 'src/app/admihair/service/contato-cliente.service';
import { AdmihairBaseComponent } from '../../admihair-base.component';
import { ErroService } from 'src/app/admihair/service/erro.service';
import { UtilStorageService } from 'src/app/admihair/service/util-storage.service';

@Component({
  selector: 'app-cliente-detalhar-janela',
  templateUrl: './cliente-detalhar-janela.component.html',
  styleUrls: ['./cliente-detalhar-janela.component.scss']
})
export class ClienteDetalharJanelaComponent extends AdmihairBaseComponent implements OnInit {

  id?: number;
  cliente?: Cliente;
  listaContatos: ContatoCliente[] = [];

  constructor(private clienteService: ClienteService,
    private contatoClienteService: ContatoClienteService,
    private activatedRouter: ActivatedRoute,
    erroService: ErroService,
    storageService: UtilStorageService) { 
      super(erroService, storageService) }

  ngOnInit(): void {
    this.setExibirSpinnerPrincipal(true);
    this.carregarIdCliente();
    this.carregarClientePorId();
  }
  
  carregarIdCliente(){
    const idParam = this.activatedRouter.snapshot.paramMap.get('id');
    if(idParam){
      this.id = parseInt(idParam);
    }
    
  }
  carregarClientePorId(){
    this.clienteService.buscarPorId(this.id).subscribe(
      (data) => {
        this.cliente = data;
        this.carregarContatosCliente();
      },
      (error) => {
        this.setExibirSpinnerPrincipal(false);
        this.exibirMensagemErro(error);
      }
    );
  }


  carregarContatosCliente(){
    this.contatoClienteService.listarPorClienteId(this.cliente?.id).subscribe(
      (data) => {
        this.listaContatos = data;
        this.setExibirSpinnerPrincipal(false);
      },
      (error) => {
        this.setExibirSpinnerPrincipal(false);
        this.exibirMensagemErro(error);
      }
    )
  }

}
